import * as Yup from 'yup';

export const personalDetailsDefState = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  street: '',
  address2: '',
  state: '',
  city: '',
  postalCode: '',
  country: '',
};

export const schema = [
  {
    name: 'firstName',
    initialValue: '',
    validation: Yup.string().required('First name is required.'),
    input: {
      placeholder: 'First Name',
      className: 'firstName',
      type: 'input',
    },
  },
  {
    name: 'lastName',
    initialValue: '',
    validation: Yup.string().required('Last name is required.'),
    input: {
      placeholder: 'Last name',
      className: 'lastName',
      type: 'input',
    },
  },
  {
    name: 'email',
    initialValue: '',
    validation: Yup.string()
      .email('Invalid email.')
      .required('Email is required.'),
    input: {
      placeholder: 'Email',
      className: 'customerEmail',
      type: 'input',
    },
  },
  {
    name: 'phone',
    initialValue: '',
    validation: null,
    input: {
      placeholder: 'Phone',
      className: 'customer-phone',
      type: 'input',
    },
  },

  {
    name: 'street',
    initialValue: '',
    validation: Yup.string(),
    input: {
      placeholder: 'Address line 1',
      className: 'customer-address-1',
      type: 'input',
    },
  },
  {
    name: 'address2',
    initialValue: '',
    validation: Yup.string(),
    input: {
      placeholder: 'Address line 2',
      className: 'customer-address-2',
      type: 'input',
    },
  },
  {
    name: 'state',
    initialValue: '',
    validation: Yup.string(),
    input: {
      placeholder: 'State',
      className: 'customer-state',
      type: 'input',
    },
  },
  {
    name: 'city',
    initialValue: '',
    validation: Yup.string(),
    input: {
      placeholder: 'City',
      className: 'customer-city',
      type: 'input',
    },
  },
  {
    name: 'postalCode',
    initialValue: '',
    validation: Yup.string(),
    input: {
      placeholder: 'ZIP',
      className: 'customer-zip',
      type: 'input',
    },
  },
  {
    name: 'country',
    initialValue: '',
    validation: Yup.string(),
    input: {
      placeholder: 'Country',
      className: 'customer-country',
      type: 'input',
    },
  },
];
